import React, { useEffect, useState } from 'react';
import { Modal } from '@mui/material';
import ModalBody from '../../ModalBody';
import CustomToggle from '../../../CustomToggle';
import CustomButton from '../../../CustomButton';
import DropDown from '../../../DropDown';
import CustomTextInput from '../../../CustomTextInput';
import { useTranslation } from 'react-i18next';
import { TruckCompany } from '../../../../services/apiSLTP/materials/trucksCompanies';
import { crudStatus } from '../../../../utils/enums';
import { getTextColor } from '../../../../utils/colors';
import ColorModal from '../../ColorModal';
import { useCreateTruckCompanyMutation, useUpdateTruckCompanyMutation } from '../../../../hooks/mutations/useTruckCompanyMutation';
import { useAuth } from '../../../../hooks/useAuth';
import { capitalizeFirstLetter } from '../../../../utils/capitalize';
import ToggleLine from '../../../ToggleLine';

interface ModalProps {
    truckCompany: TruckCompany | null;
    isEditMode?: boolean;
    showEditModal: boolean;
    setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
    refetch: () => void;
}

const UpdateTruckCompanyModal: React.FC<ModalProps> = ({
    truckCompany,
    isEditMode = true,
    showEditModal,
    setShowEditModal,
    refetch,
}) => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const [designation, setDesignation] = useState(truckCompany?.designation || '');
    const [email, setEmail] = useState(truckCompany?.email || '');
    const [isActive, setIsActive] = useState(truckCompany?.crudStatus ? truckCompany?.crudStatus === crudStatus.OK : true);
    const [isOwnCompany, setIsOwnCompany] = useState(truckCompany?.isOwnCompany || false);
    

    const {
        mutate: mutateTruckCompany,
        isSuccess: isSuccessTruckCompany,
        isError: isErrorTruckCompany,
        isLoading: isLoadingTruckCompany,
        error: errorTruckCompany,
        data: dataTruckCompany,
    } = useUpdateTruckCompanyMutation({
        onSuccess: () => refetch(),
        onError: (error) => {
            console.error('Error updating truckCompany:', error.message);
        },
    });

    const {
        mutate: addTruckCompany,
        isSuccess: isSuccessAdded,
        isError: isErrorAdded,
        isLoading: isLoadingAdded,
        error: errorAdded,
        data: dataAdded,
    } = useCreateTruckCompanyMutation({
        onSuccess: () => refetch(),
        onError: (error) => {
            console.error('Error adding truckCompany:', error.message);
        },
    });

    const handleSubmit = () => {
        if (isEditMode) {
            mutateTruckCompany({
                truckCompanyId: truckCompany?._id || '',
                data: { designation, crudStatus: isActive ? crudStatus.OK : crudStatus.INACTIVE, email, isOwnCompany },
            });
        } else {
            addTruckCompany({ designation, crudStatus: isActive ? crudStatus.OK : crudStatus.INACTIVE, email, isOwnCompany });
        }
    };

    return (
        <ModalBody
            title={t('truckCompany')}
            subTitle={isEditMode ? t('update') : t('add')}
            closeText={t('cancel')}
            okText={t('validate')}
            open={showEditModal}
            handleClose={() => setShowEditModal(false)}
            disabledOk={!designation.length}
            handleOk={handleSubmit}
        >
            <CustomTextInput value={designation} label={t('name')} onChange={setDesignation} required />
            <ToggleLine checked={isActive} onChange={setIsActive} title={capitalizeFirstLetter(t('active'))} />
            <CustomTextInput value={email} label={t('email')} onChange={setEmail} />
            <ToggleLine checked={isOwnCompany} onChange={setIsOwnCompany} title={capitalizeFirstLetter(t('isOwnCompany'))} />
        </ModalBody>
    );
};

export default UpdateTruckCompanyModal;
